exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_object-gops.js
// module id = 121
// module chunks = 2 92